import { mentionClipRange } from "../../utils/videoMentionPlayback.ts";
import type { MentionedVideoItem } from "../VideoMention.tsx";

const HEADER = [
	"video_id",
	"title",
	"creator",
	"platform",
	"post_url",
	"start_sec",
	"end_sec",
	"duration_sec",
];

/*
 * Titles and handles come from social posts, so a cell starting with one of
 * these would run as a formula when the file is opened in a spreadsheet.
 */
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

function csvCell(value: string | number | null | undefined): string {
	if (value === null || value === undefined) {
		return "";
	}
	let text = String(value);
	if (typeof value === "string" && FORMULA_PREFIX.test(text)) {
		text = `'${text}`;
	}
	return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

function seconds(value: number): string {
	return String(Math.round(value * 1000) / 1000);
}

/** One row per clip, in clipboard order, with times in seconds on the source video. */
export function clipboardCsv(mentions: MentionedVideoItem[]): string {
	const rows = mentions.map((mention) => {
		const { start, end } = mentionClipRange(mention);
		return [
			csvCell(mention.video_id ?? mention.id),
			csvCell(mention.title),
			csvCell(
				mention.social_account?.handle ??
					mention.influencer?.handle ??
					mention.influencer?.display_name,
			),
			csvCell(mention.social_account?.platform),
			csvCell(mention.post_url),
			seconds(start),
			seconds(end),
			seconds(end - start),
		].join(",");
	});
	// The BOM makes Excel read the file as UTF-8 rather than mangling emoji in titles.
	return `\uFEFF${[HEADER.join(","), ...rows].join("\r\n")}\r\n`;
}

export function clipboardCsvFilename(now: Date = new Date()): string {
	return `clipboard-clips-${now.toISOString().slice(0, 10)}.csv`;
}
